import format from './format'
import keys from './keys'

export default {
  namespaced: true,
  modules: {
    format,
    keys
  }
}
